// extracted by mini-css-extract-plugin
export default {"loadingIndicator":"VDPRbDtyKIcrgVexpJ2E"};